import { Grid } from "@material-ui/core";
import TenantOnIcon from "../../../../assets/images/dashboard/tenantOn.png";
import TenantOffIcon from "../../../../assets/images/dashboard/tenantOff.png";
import TenantHalfIcon from "../../../../assets/images/dashboard/tenantHalf.png";
import { Icon } from "../../../../components/base/Icon";

const MAX_VALUE = 10;

export const PeopleBarProgress = ({ percentage }) => {
  const value = (percentage * MAX_VALUE) / 100;
  const valueInt = parseInt(value);
  const hasHalf = !Number.isInteger(value);

  return (
    <Grid container>
      {Array.from({ length: valueInt }, () => (
        <Icon key={Math.random()} src={TenantOnIcon} />
      ))}
      {hasHalf && <Icon src={TenantHalfIcon} />}
      {Array.from(
        { length: hasHalf ? MAX_VALUE - valueInt - 1 : MAX_VALUE - valueInt },
        () => (
          <Icon key={Math.random()} src={TenantOffIcon} />
        )
      )}
    </Grid>
  );
};
